import { ResourceMaturity } from "@examspark/types";

export const defaultProductLicenseMaturityFilter = [
  ResourceMaturity.Operational,
];
